module.exports = __webpack_public_path__ + "img/googleplay.720e7dc7.png";